import { getAdminNotifications } from "features/admin/presentation/slices/get-admin-notifications.slice";
import { selectGetAdminSession } from "features/admin/presentation/slices/get-admin-session.slice";
import { getAdminShopOrders } from "features/admin/presentation/slices/get-admin-shop-orders.slice";
import {
  useAppDispatch,
  useAppSelector,
  useQuery,
} from "features/config/hooks";
import { pusher } from "features/shared/constants";
import { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import { getStockOrders } from "../slices/get-stock-orders.slice";
import { createQueryParams } from "features/config/helpers";
import { useActionAvailability } from "./stock-ordering-utils";
import { start } from "repl";
import { resetGetProductData } from "../slices/get-product-data.slice";

interface TransactionParam {
  store_id: number | undefined;
  message: string;
}

export function StockOrderingBadgeWrapper() {
  const { processId } = useActionAvailability();

  const dispatch = useAppDispatch();
  const { view, orderId } = useParams();
  const getAdminSessionState = useAppSelector(selectGetAdminSession);
  const query = useQuery();
  const pageNo = query.get("page_no");
  const perPage = query.get("per_page");
  const orderBy = query.get("order_by");
  const order = query.get("order");
  const search = query.get("search");

  const tabValue = query.get("tab");
  const dateType = query.get("dateType");
  const startDate = query.get("startDate");
  const endDate = query.get("endDate");

  useEffect(() => {
    pusher.unsubscribe("admin-stock-ordering");
    const stockOrderingChannel = pusher.subscribe("admin-stock-ordering");

    stockOrderingChannel.bind(
      "stockorder-process",
      (data: TransactionParam) => {
        const query = createQueryParams({
          page_no: pageNo,
          per_page: perPage,
          order_by: orderBy,
          order: order,
          search: search,
          dateType: dateType,
          startDate: startDate,
          endDate: endDate,
          tab: tabValue,
        });

        dispatch(getStockOrders({ query: query, view, processId: processId }));
        dispatch(resetGetProductData());
      }
    );
  }, [
    getAdminSessionState,
    dispatch,
    tabValue,
    pageNo,
    perPage,
    orderBy,
    order,
    search,
  ]);

  useEffect(() => {
    pusher.unsubscribe("admin-stock-ordering");
    const stockOrderingChannel = pusher.subscribe("admin-stock-ordering");
    stockOrderingChannel.bind(
      "stockorder-process-update",
      (data: { orderId: string }) => {
        if (data.orderId === orderId) {
          dispatch(resetGetProductData());
        }
      }
    );
  }, [dispatch, orderId]);

  return (
    <>
      <Outlet />
    </>
  );
}
